<template>
  <div class="shop-product-wrap grid gridview-3 img-hover-effect_area row">
              <div v-for="product in products" :key="product.name" class="col-lg-4">
                <div class="product-slide_item">
                  <div class="inner-slide">
                    <div class="single-product">
                      <div class="product-img">
                        <router-link to="/product">
                          <img class="primary-img" :src="product.img[0]"
                            :alt="product.name">
                          <img class="secondary-img" :src="product.img[1]"
                            :alt="product.name">
                        </router-link>
                        <div v-if="product.new" class="sticker">
                          <span class="sticker">New</span>
                        </div>
                        <div class="add-actions">
                          <ul>
                            <li><a class="uren-add_cart" href="cart.html" data-toggle="tooltip" data-placement="top"
                                title="Add To Cart"><i class="fas fa-shopping-cart"></i></a>
                            </li>
                            
                            <li class="quick-view-btn" data-toggle="modal" data-target="#exampleModalCenter"><a
                                href="javascript:void(0)" data-toggle="tooltip" data-placement="top"
                                title="Quick View"><i class="ion-android-open"></i></a></li>
                          </ul>
                        </div>
                      </div>
                      <div class="product-content">
                        <div class="product-desc_info">
                          <div class="rating-box">
                            <ul>
                              <li><i class="ion-android-star"></i></li>
                              <li><i class="ion-android-star"></i></li>
                              <li><i class="ion-android-star"></i></li>
                              <li class="silver-color"><i class="ion-android-star"></i>
                              </li>
                              <li class="silver-color"><i class="ion-android-star"></i>
                              </li>
                            </ul>
                          </div>
                          <h6><router-link class="product-name" to="/product">{{ product.name }}</router-link></h6>
                          <div class="price-box">
                            <span class="new-price">${{ product.price }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-slide_item">
                  <div class="single-product">
                    <div class="product-img">
                      <router-link to="/product">
                       <img class="primary-img" :src="product.img[0]"
                            :alt="product.name">
                          <img class="secondary-img" :src="product.img[1]"
                            :alt="product.name">
                      </router-link>
                    </div>
                    <div class="product-content">
                      <div class="product-desc_info">
                        <div class="rating-box">
                          <ul>
                            <li><i class="ion-android-star"></i></li>
                            <li><i class="ion-android-star"></i></li>
                            <li><i class="ion-android-star"></i></li>
                            <li class="silver-color"><i class="ion-android-star"></i>
                            </li>
                            <li class="silver-color"><i class="ion-android-star"></i>
                            </li>
                          </ul>
                        </div>
                        <h6><router-link class="product-name" to="/product">{{product.name}}</router-link></h6>
                        <div class="price-box">
                          <span class="new-price">${{product.price}}</span>
                        </div>
                        <div class="product-short_desc">
                          <p>{{product.desc}}</p>
                        </div>
                      </div>
                      <div class="add-actions">
                        <ul>
                          <li><a class="uren-add_cart" href="cart.html" data-toggle="tooltip" data-placement="top"
                              title="Add To Cart"><i class="fas fa-shopping-cart"></i></a>
                          </li>
                          
                          <li class="quick-view-btn" data-toggle="modal" data-target="#exampleModalCenter"><a
                              href="javascript:void(0)" data-toggle="tooltip" data-placement="top" title="Quick View"><i
                                class="ion-android-open"></i></a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
</template>

<script>
export default {
  name: "DisplayProducts",
  props: ['products'],
}
</script>

<style>

</style>
